import { render, staticRenderFns } from "./ApplicationActivities.vue?vue&type=template&id=dc9594da&scoped=true&"
import script from "./ApplicationActivities.vue?vue&type=script&lang=js&"
export * from "./ApplicationActivities.vue?vue&type=script&lang=js&"
import style0 from "@/assets/sass/pages/activities/activities.scss?vue&type=style&index=0&id=dc9594da&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc9594da",
  null
  
)

export default component.exports